import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import {
  Shield,
  FileText,
  Search,
  ShoppingBag,
  Building2,
  Award,
  Zap,
  DollarSign,
  HeadphonesIcon,
  CheckCircle,
  Star,
  ArrowRight,
  Check,
} from "lucide-react";

const iconMap = {
  Shield,
  FileText,
  Search,
  ShoppingBag,
  Building2,
  Award,
  Zap,
  DollarSign,
  HeadphonesIcon,
  CheckCircle,
};

const WhyChooseUsSlider = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 664) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleItems = () => {
    const result = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const index = (currentIndex + i) % items.length;
      result.push(items[index]);
    }
    return result;
  };

  return (
    <div className="relative">
      {itemsPerPage === 1 ? (
        // Mobile: Slider mode
        <>
          <div className="grid gap-6 grid-cols-1">
            {getVisibleItems().map((item, index) => {
              const Icon = typeof item.icon === "string" ? iconMap[item.icon] : item.icon;
              return (
                <Card
                  key={`${item.id}-${currentIndex}`}
                  className="border-2 border-blue-100 hover:border-blue-300 transition-all duration-500 hover:shadow-xl"
                >
                  <CardContent className="pt-6 text-center">
                    <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                      <Icon className="w-8 h-8 text-blue-600" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{item.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {items.length > itemsPerPage && (
            <div className="flex justify-center gap-3 mt-8">
              {Array.from({ length: items.length }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? "bg-brand-purple w-8"
                      : "bg-gray-300 hover:bg-brand-purple/50"
                  }`}
                  aria-label={`Go to item ${index + 1}`}
                />
              ))}
            </div>
          )}
        </>
      ) : (
        // Desktop: Static grid mode
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item, index) => {
            const Icon = typeof item.icon === "string" ? iconMap[item.icon] : item.icon;
            return (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300"
              >
                <div className="mx-auto w-16 h-16 bg-gradient-to-r from-brand-purple to-brand-pink rounded-full flex items-center justify-center mb-4 animate-float">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">{item.description}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WhyChooseUsSlider;
